import React from 'react';
import { Link, Typography } from '@one-thd/sui-atomic-components';

const ErrorModalBodyTextEnum = {
  MULTI_SHIPPING_ADDRESS: (
    <Typography variant="body-base">
      This combination of items cannot be returned online. You can return an
      item at any The Home Depot store, or call Customer Support at{' '}
      <Link href="tel:+1-800-430-3376">1-800-430-3376</Link> if you have
      questions. See our{' '}
      <Link href="https://www.homedepot.com/c/Pro_Return_Policy">
        Returns Policy
      </Link>{' '}
      for more information.
    </Typography>
  ),
  HAS_INELIGIBLE_ITEMS: (
    <Typography variant="body-base">
      These items can&apos;t be returned online. You can return an item at any
      The Home Depot store, or call Customer Support at{' '}
      <Link href="tel:+1-800-430-3376">1-800-430-3376</Link> if you have
      questions. See our{' '}
      <Link href="https://www.homedepot.com/c/Pro_Return_Policy">
        Returns Policy
      </Link>{' '}
      for more information.
    </Typography>
  ),
};

export const getErrorModalBodyText = (policyValidatorAlert: string) => {
  if (policyValidatorAlert === 'MULTI_SHIPMENTS') {
    return ErrorModalBodyTextEnum.MULTI_SHIPPING_ADDRESS;
  }
  if (policyValidatorAlert === 'HAS_INELIGIBLE_ITEMS') {
    return ErrorModalBodyTextEnum.HAS_INELIGIBLE_ITEMS;
  }
  return ErrorModalBodyTextEnum.MULTI_SHIPPING_ADDRESS;
};
